import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Modal, Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";

import { fetchWithCX, fetchWithToken } from "../../api/fetch";
import { ChatContext } from "../../context/chat/ChatContext";
import { SocketContext } from "../../context/SocketContext";
import { AuthContext } from "../../context/AuthContext";
import toastConfig from "../../utils/toastConfig";

const ModalClients = ({ show, handleClose }) => {
  const { socket } = useContext(SocketContext);

  const [selectedOption, setSelectedOption] = useState(null);
  const [error, setError] = useState("Sin clientes");
  const [customers, setCustomers] = useState([]);
  const [send, setSend] = useState(false);
  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;
  useEffect(() => {
    getClientes();
  }, []);

  const getClientes = async () => {
    const res = await fetchWithCX("chat/clientes");
    if (res.ok) {
      setCustomers(res.data);
    } else {
      setError("Error en la conexión");
    }
  };
  const handleSave = async () => {
    setSend(true);
    let customer = selectedOption.label.replace(/^\d+\s*-\s*/, "");
    const resp = await fetchWithToken(
      `cx/asignar`,
      { id: activeChat.id, value: selectedOption.value, customer },
      "POST"
    );

    if (resp.ok) {
      socket.emit("asignarcx", {
        id: activeChat.id,
      });
      toast.success(resp.msg, toastConfig);
    }
    setSend(false);
    handleClose();
    setSelectedOption(null);
  };
  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Asignar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                {error && !customers ? (
                  <h4>{error}</h4>
                ) : (
                  <div className="selct">
                    <Form.Label>Selecciona un cliente</Form.Label>
                    <Select
                      value={selectedOption}
                      onChange={setSelectedOption}
                      options={customers}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="fw-bolder"
            onClick={handleClose}
          >
            Cancelar
          </Button>

          {send ? (
            <>
              <Button variant="secondary" className="fw-bolder">
                Guardando...
              </Button>
            </>
          ) : (
            <Button
              variant="primary"
              className="fw-bolder"
              onClick={handleSave}
              disabled={selectedOption ? false : true}
            >
              Guardar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalClients;
